import { render, staticRenderFns } from "./app-ivestor.vue?vue&type=template&id=19d8bae0"
import script from "./app-ivestor.vue?vue&type=script&lang=js"
export * from "./app-ivestor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports